import { zodResolver } from '@hookform/resolvers/zod';
import { User } from 'shared/model/user.model';
import { z, ZodType } from 'zod';

// Begin with https://transform.tools/typescript-to-zod

const useUserResolver = (existingUsers: User[]) => {
  const message = 'Field is mandatory';

  const usedEmails = existingUsers.map(user => user.email);

  const schema = z.object({
    email: z
      .string()
      .email()
      .refine(email => !usedEmails.includes(email), {
        message: 'This email is already in use, please choose another one.',
      }),
    firstName: z.string().min(1, { message }),
    lastName: z.string().min(1, { message }),
    company: z.string().min(1, { message }),
  }) satisfies ZodType<Omit<User, 'id'>>;

  return zodResolver(schema);
};

export default useUserResolver;
